import { useMutation, useQueryClient } from 'react-query'

import { customFieldRepository } from '@webapp/core/data-access/repositories/CustomFieldRepository/CustomFieldRepository'
import { customFieldQueryConfig } from '@webapp/core/query-configs/customField'
import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { poPdfLabelEditorQueryConfig } from '@webapp/modules/purchasing/query-configs/poPdfLabelEditor'

export const useMutateDeletePOCustomField = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, number>({
    mutationFn: (id: number) => customFieldRepository.disableCustomField(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: customFieldQueryConfig.allPurchaseOrder().queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: poPdfLabelEditorQueryConfig.editorFields().queryKey,
      })
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
